'use client';
import { Link } from '@/i18n/routing';

import { useTranslations } from 'next-intl';
import ErrorPageLayout from './ErrorPageLayout';

export default function NotFoundContainer() {
    const t = useTranslations('errors');
    const refreshPage = () => {
        window.location.reload();
    };

    return (
        <ErrorPageLayout
          title={t('not_found.title')}
          subtitle={t('not_found.subtitle')}
          description={t('not_found.description')}
          imageSrc='/img/errors/not-found.png'
          actions={
                <>
                <Link href='/'>
                    <ErrorPageLayout.Button
                      variant='stroke'
                      size='lg'
                      innerText={t('common.dashboard')}
                    />
                </Link>
                <ErrorPageLayout.Button
                  variant='filled'
                  size='lg'
                  innerText={t('common.refresh')}
                  onClick={refreshPage}
                />
                </>
            }
        />
    );
}
